module.exports = __webpack_public_path__ + "static/img/supplier3.4bcb2e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplier3.png
// module id = YLDS
// module chunks = 192